var map = {
	"./trusted-clients-en.png": "vFpm",
	"./trusted-clients-fr.png": "ngZX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J2rP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete ^\.\/trusted\-clients\-.*\.png$
// module id = J2rP
// module chunks = 0